import './App.css';
import React from 'react';
import * as Feather from 'react-feather';

const COLORS = {
  red: ['#c0392b','#e74c3c'],
  green: ['#27ae60', '#2ecc71'],
  yellow: ['#e67e22','#f39c12'],
  grey: ['#1e1e1e', '#2e2e2e']
}

function TopBarButton({colorScheme, icon}) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div style={{
           width: '1rem',
           height: '1rem',
           background: colorScheme[1>>!hovered],
           borderRadius: '50px',
           border: `2px solid ${colorScheme[1>>!hovered]}`,
           color: 'white',
           alignItems: 'center',
           justifyContent: 'center',
           lineHeight: '1rem',
           textAlign: 'center',
           padding: '0.1rem',
           transition: 'color .4s',
         }}
         onMouseEnter={()=>setHovered(true)}
         onMouseLeave={()=>setHovered(false)}
    >
      <div style={{
             opacity: 1>>!hovered,
             transition: 'opacity .4s',
             display: 'flex',
           flexDirection: 'row',
           alignItems: 'center',
           justifyContent: 'center'
           }}>
        {icon}
        </div>
      </div>
  );
}

function WindowTopBar() {
  return (
    <div style={{
           width: '100%',
           borderTopLeftRadius: '12px',
           borderTopRightRadius: '12px',
           background: '#0e0e0e',
           height: '2.4rem',
           position: 'absolute',
           top:0,
           left:0,
           display: 'flex',
           flexDirection: 'row',
           alignItems: 'center',
           justifyContent: 'left'
         }}>
      <div style={{
            display: 'flex',
             flexDirection: 'row',
             justifyContent: 'space-evenly',
             width: '7rem'
           }}>
        <TopBarButton  colorScheme={COLORS.red} icon={<Feather.X size={18}/>}/>
        <TopBarButton  colorScheme={COLORS.green} icon={<Feather.ChevronLeft size={18}/>}/>
        <TopBarButton  colorScheme={COLORS.yellow} icon={<Feather.Minus size={18}/>}/>
        </div>
      </div>
  );
}

function URLBarButton({icon, colorScheme, onClick=()=>{}}) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div style={{
           background: colorScheme[1>>!hovered],
           borderRadius: '50px',
           width: '1.2rem',
           height: '1.2rem',
           display: 'flex',
           flexDirection: 'row',
           alignItems: 'center',
           justifyContent: 'center',
           color: '#aeaeae',
           padding: '0.2rem',
           transition: 'background .4s',
           margin: '0.2rem'
         }}
         onMouseEnter={()=>setHovered(true)}
         onMouseLeave={()=>setHovered(false)}
         onClick={onClick}
    >
      {icon}
      </div>
  );
}

function URLInput({url, onURLChange=()=>{}}) {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div style={{
           display: 'flex',
           flexDirection: 'row',
           width: '50%'
         }}
         onMouseEnter={()=>setHovered(true)}
         onMouseLeave={()=>setHovered(false)}
    >
      <input type="url" value={url} onChange={(e)=>{
               onURLChange(e.target.value);
             }}
             style={{
               background: ['#000000', '#050505'][1>>!hovered],
               color: '#5e5e5e',
               border: 'none',
               padding: '0.4rem 0.8rem',
               width: '100%',
               outline: 'none',
               borderRadius: '2px',
               transition: 'background .4s',
               height: '1.4rem'
             }}
             placeholder={'URL'}
      ></input>
      </div>
  );
}

function URLBar({url, onURLChange=()=>{}, allowed}) {
  const [u, setU] = React.useState('https://ccw.icu');
  return (
    <div style={{
           width: 'calc(100% - 6px - 0.4rem)',
           height: '2rem',
           position: 'absolute',
           left: 0,
           top: '2.4rem',
           background: '#0e0e0e',
           border: '3px solid #0e0e0e',
           display: 'flex',
           flexDirection: 'row',
           alignItems: 'center',
           justifyContent: 'space-evenly',
           padding: '0.2rem'
         }}>
      <URLBarButton icon={<Feather.ChevronLeft size={14}/>} colorScheme={COLORS.grey}/>
      <URLBarButton icon={<Feather.ChevronRight size={14}/>} colorScheme={COLORS.grey}/>
      <URLBarButton icon={<Feather.RotateCw size={14}/>} colorScheme={COLORS.grey}/>
      <URLBarButton icon={<Feather.Home size={14}/>} colorScheme={COLORS.grey}/>
      <URLInput url={u} onURLChange={(v)=>setU(v)}/>
      <URLBarButton icon={<Feather.Search size={14}/>} colorScheme={COLORS.grey} onClick={()=>{
                      // Load URL
                      let allow = false;
                      allowed.urls.forEach((uri)=>{
                        if(uri===u || (uri.endsWith('*') && u.startWith(u.slice(0, -1)))) allow = true;
                      })
                      if(allow) onURLChange(u);
                    }}/>
      <URLBarButton icon={<Feather.Star size={14}/>} colorScheme={COLORS.grey}/>
      <URLBarButton icon={<Feather.MoreVertical size={14}/>} colorScheme={COLORS.grey}/>
      </div>
  );
}

function BrowserWindow() {
  const [url, setURL] = React.useState('https://ccw.icu');
  const [allowed, setAllowed] = React.useState({urls:['https://ccw.icu', 'https://jusax.de']});

  return (
    <div style={{
           position: 'fixed',
           top: '0.2rem',
           left: '0.2rem',
           width: 'calc(100% - 0.4rem)',
           height: 'calc(100% - 0.4rem)',
           borderRadius: '5px',
           overflow: 'hidden'
         }}>
      <WindowTopBar />
      <URLBar allowed={allowed} onURLChange={(v)=>setURL(v)} url={url}/>
      <iframe
        style={{
          width: 'calc(100% - 6px)',
          height: 'calc(100% - 2.4rem - 6px - 2.6rem)',
          position: 'absolute',
          bottom: 0,
          left: 0,
          border: '3px solid #0e0e0e',
          background: '#ffffff',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
           overflow: 'hidden'
        }}
        src={url}>
        </iframe>
    </div>
  );
}

function App() {
  return (
    <div className="App" style={{
           background: '#282828',
           width: '100%',
           height: '100%',
           position: 'absolute'
         }}>
      <BrowserWindow />
      <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ?controls=0&autoplay=1&loop=1&amp;start=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  );
}

export default App;
